export default __webpack_public_path__ + "79d025d1802e3e815cfb04aab6ed7b4a.png";